import api from '../api/api';

const getMyResourceEnrollments = async () => {
  try {
    const response = await api.get('/resource-enrollments/my-enrollments');
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

const checkResourceEnrollment = async (resourceId) => {
  try {
    // [FIX] Changed from query param (?resourceId=) to path variable (/${resourceId})
    // to match the backend controller's @GetMapping("/check/{resourceId}")
    const response = await api.get(`/resource-enrollments/check/${resourceId}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

const resourceEnrollmentService = {
  getMyResourceEnrollments,
  checkResourceEnrollment,
};

export default resourceEnrollmentService;
